import { render } from "./RoleList.vue?vue&type=template&id=57bf0c0f&scoped=true&ts=true"
import script from "./ts/roleListHelper.ts?vue&type=script&lang=ts"
export * from "./ts/roleListHelper.ts?vue&type=script&lang=ts"

import "./RoleList.vue?vue&type=style&index=0&id=57bf0c0f&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bf0c0f"]])

export default __exports__